import React, { useState } from 'react';
import '../css/Quiz.css';

const questions = [
    {
      questionText: '신혼여행지로 올바른 곳은?',
      correctAnswer: '저희는 스위스, 스페인으로 여행갑니다.',
      answerOptions: [
        { answerText: '호주', isCorrect: false },
        { answerText: '캐나다', isCorrect: false },
        { answerText: '스위스', isCorrect: true },
        { answerText: '영국', isCorrect: false },
        { answerText: '스페인', isCorrect: true },
      ],
    },
    {
      questionText: '함께 여행한 국가가 아닌 곳은?',
      correctAnswer: '오키나와 수족관을 다녀왔어요.',
      answerOptions: [
        { answerText: '일본', isCorrect: true },
        { answerText: '홍콩', isCorrect: false },
        { answerText: '마카오', isCorrect: false },
        { answerText: '라오스', isCorrect: false },
        { answerText: '베트남', isCorrect: false },
      ],
    },
    {
      questionText: '함께 하지 않은 활동은?',
      correctAnswer: '게임을 좋아하지만, PC방에서 함게 게임한적은 없어요.',
      answerOptions: [
        { answerText: '마라톤 10km 뛰기', isCorrect: false },
        { answerText: '한강 수영하기', isCorrect: false },
        { answerText: '자전거 경주 나가기', isCorrect: false },
        { answerText: '등산하기', isCorrect: false },
        { answerText: 'PC방에서 게임하기', isCorrect: true },
      ],
    }
  ];


function Quiz() {

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [showScore, setShowScore] = useState(false);
    const [score, setScore] = useState(0);
    const [answerFeedback, setAnswerFeedback] = useState(null);
    const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);


    const handleAnswerButtonClick = (correctAnswer, isCorrect, index) => {
        const nextQuestion = currentQuestion + 1;
        setSelectedOptionIndex(index);
    
        if (isCorrect) {
          setScore(score + 1);
          setAnswerFeedback(`정답입니다!`);
        } else {
          setAnswerFeedback(`틀렸습니다! ${correctAnswer} `);
        }
    
        setTimeout(() => {
          if (nextQuestion < questions.length) {
            setCurrentQuestion(nextQuestion);
          } else {
            setShowScore(true);
          }
          setAnswerFeedback(null);
          setSelectedOptionIndex(null);
        }, 3000);
      };

      const handleRestart = () => {
        setCurrentQuestion(0);
        setShowScore(false);
        setScore(0);
        setSelectedOptionIndex(null);
      };

  return (
    <div className='container bc-pink'>
        <div className='title'>깜짝 퀴즈</div>
        {showScore ? (
        <div className='score-section'>
          <div>{questions.length} 문제 중에 <span className='my-score'>{score} 문제</span> 맞혔습니다! </div>
          <button onClick={handleRestart} className='restart-button'>다시하기</button> 
        </div>
        ) : (
            <>
            <div className='question-section'>
                <div className='question-count'>
                <span>문제 {currentQuestion + 1}</span>/{questions.length}
                </div>
                <div className='question-text'>
                  <div>신랑♥신부</div>
                  <div>{questions[currentQuestion].questionText}</div>
                </div>
            </div>
            <div className='answer-section'>
                {questions[currentQuestion].answerOptions.map((answerOption, index) => (
                <button
                    className={`answer-button ${selectedOptionIndex === index ? (answerOption.isCorrect ? 'correct' : 'incorrect') : ''}`}
                    onClick={() => handleAnswerButtonClick(questions[currentQuestion].correctAnswer, answerOption.isCorrect, index)}
                    key={index}
                >
                    {answerOption.answerText}
                </button>
                ))}
            </div>
            {answerFeedback && <div className='feedback'>{answerFeedback}</div>}
            </>
        )}
    </div>
  )
}

export default Quiz